import type { IProductParams } from '~/types/product-listing'

export const useProductState = () => {

    const dataFilters = ref([]);
    const productParams = useState<IProductParams>('productParams', () => ({
        page: 1,
        category: '',
        material: '',
        gemstone: '',
        collection: '',
        metal_color: '',
        recipients: '',
        price: '',
        cost: '',
        default: '',
        orderby: 'latest'
    }))

    const setProductFilters = () => {
        dataFilters.value = []
    }


    const resetParams = (defaultParams = {}) => {
        // console.log('resetParams1111111111', defaultParams);
        const { orderby } = productParams.value
        productParams.value = {
            page: 1,
            category: '',
            material: '',
            gemstone: '',
            collection: '',
            metal_color: '',
            recipients: '',
            price: '',
            cost: '',
            default: '',
            orderby,
            ...defaultParams
        }
    }
    return {
        dataFilters,
        productParams,
        setProductFilters,
        resetParams
    }
}